import { FilterSchema } from '@/components/ResourcesSidebar/ResourcesSidebarHelpers';
import { FormattedMessage } from 'react-intl';

export const SortByOptions = [
  {
    id: 1,
    label: <FormattedMessage id="date" defaultMessage="Date" />,
    value: 'date',
  },
  {
    id: 2,
    label: <FormattedMessage id="name" defaultMessage="Name" />,
    value: 'name',
  },
  // {
  //   id: 3,
  //   label: (
  //     <FormattedMessage id="fileSize" defaultMessage="File Size" />
  //   ),
  //   value: 'fileSize',
  // },
];

export const GamesSortByOptions = [
  {
    id: 1,
    label: (
      <FormattedMessage
        id="releaseDate"
        defaultMessage="Release Date"
      />
    ),
    value: 'release_date',
  },
  {
    id: 2,
    label: <FormattedMessage id="name" defaultMessage="Name" />,
    value: 'game_name',
  },
  {
    id: 3,
    label: <FormattedMessage id="date" defaultMessage="Date" />,
    value: 'date',
  },
  {
    id: 4,
    label: <FormattedMessage id="rtp" defaultMessage="RTP" />,
    value: 'rtp',
  },
  {
    id: 5,
    label: <FormattedMessage id="status" defaultMessage="Status" />,
    value: 'status',
  },
];

export const mapFiltersToParams = (
  filters?: Partial<FilterSchema>,
  sortBy?: string,
  additionalParams?: Record<string, string>,
) => {
  const {
    market,
    volatility,
    language,
    rtp,
    releaseDate,
    gameStatus,
    gameFamily,
    gameFeatures,
    gameGroups,
    gameProviders,
    fileTypeMarketing,
    fileFormatMarketing,
    fileTypeCompliance,
    fileFormatCompliance,
    partnerType,
    platform,
    operator,
    brand,
  } = filters || {};
  const rawReleaseDateFrom = releaseDate?.[0];
  const rawReleaseDateTo = releaseDate?.[1];
  const releaseDateFrom = rawReleaseDateFrom;
  const releaseDateTo =
    rawReleaseDateTo ||
    (rawReleaseDateFrom ? rawReleaseDateFrom : undefined);

  return {
    ...(market ? { market_ids: market } : {}),
    ...(volatility
      ? {
          volatility_from: Number(volatility?.[0]) || 0,
          volatility_to: Number(volatility?.[1]) || 0,
        }
      : {}),
    ...((language?.length || 0) > 0 ? { languages: language } : {}),
    ...(rtp?.length === 1
      ? {
          rtp_from: rtp[0]?.[0],
          rtp_to: rtp[0]?.[1],
        }
      : {}),
    ...(releaseDateFrom
      ? { release_date_from: releaseDateFrom }
      : {}),
    ...(releaseDateTo ? { release_date_to: releaseDateTo } : {}),
    ...(additionalParams ? additionalParams : {}),
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...((gameStatus?.length || 0) > 0
      ? { game_status: gameStatus }
      : {}),
    ...((gameFamily?.length || 0) > 0
      ? { game_family: gameFamily }
      : {}),
    ...((gameFeatures?.length || 0) > 0
      ? { game_features: gameFeatures }
      : {}),
    ...((gameGroups?.length || 0) > 0
      ? { game_group: gameGroups }
      : {}),
    ...((gameProviders?.length || 0) > 0
      ? { game_provider: gameProviders }
      : {}),
    ...((fileTypeMarketing?.length || 0) > 0
      ? { file_types: fileTypeMarketing }
      : {}),
    ...((fileFormatMarketing?.length || 0) > 0
      ? { extensions: fileFormatMarketing }
      : {}),
    ...((fileTypeCompliance?.length || 0) > 0
      ? { document_types: fileTypeCompliance }
      : {}),
    ...((fileFormatCompliance?.length || 0) > 0
      ? { extensions: fileFormatCompliance }
      : {}),
    ...((partnerType?.length || 0) > 0 ? { type: partnerType } : {}),
    ...((platform?.length || 0) > 0
      ? { platform_names: platform }
      : {}),
    ...((operator?.length || 0) > 0
      ? { operator_names: operator }
      : {}),
    ...((brand?.length || 0) > 0 ? { brand_names: brand } : {}),
  };
};

export const parseFiltersFromSearchParams = (
  searchParams: URLSearchParams,
): Partial<FilterSchema> => {
  const filters: Partial<FilterSchema> = {};

  const markets = searchParams
    .getAll('market')
    .map((v) => parseInt(v, 10))
    .filter((v) => !Number.isNaN(v));
  if (markets.length > 0) {
    filters.market = markets;
  }

  const languages = searchParams.getAll('language');
  if (languages.length > 0) {
    filters.language = languages;
  }

  const gameStatus = searchParams.getAll('game_status');
  if (gameStatus.length > 0) {
    filters.gameStatus = gameStatus;
  }

  const gameFeatures = searchParams.getAll('game_features');
  if (gameFeatures.length > 0) {
    filters.gameFeatures = gameFeatures;
  }

  const gameFamily = searchParams.getAll('game_family');
  if (gameFamily.length > 0) {
    filters.gameFamily = gameFamily;
  }

  const gameGroups = searchParams.getAll('game_groups');
  if (gameGroups.length > 0) {
    filters.gameGroups = gameGroups;
  }

  const gameProviders = searchParams.getAll('game_providers');
  if (gameProviders.length > 0) {
    filters.gameProviders = gameProviders;
  }

  const fileTypeCompliance = searchParams.getAll(
    'file_type_compliance',
  );
  if (fileTypeCompliance.length > 0) {
    filters.fileTypeCompliance = fileTypeCompliance;
  }

  const fileFormatCompliance = searchParams.getAll(
    'file_format_compliance',
  );
  if (fileFormatCompliance.length > 0) {
    filters.fileFormatCompliance = fileFormatCompliance;
  }

  const fileTypeMarketing = searchParams.getAll(
    'file_type_marketing',
  );
  if (fileTypeMarketing.length > 0) {
    filters.fileTypeMarketing = fileTypeMarketing;
  }

  const fileFormatMarketing = searchParams.getAll(
    'file_format_marketing',
  );
  if (fileFormatMarketing.length > 0) {
    filters.fileFormatMarketing = fileFormatMarketing;
  }

  const partnerType = searchParams.getAll('partner_type');
  if (partnerType.length > 0) {
    filters.partnerType = partnerType;
  }

  const platform = searchParams.getAll('platform');
  if (platform.length > 0) {
    filters.platform = platform;
  }

  const operator = searchParams.getAll('operator');
  if (operator.length > 0) {
    filters.operator = operator;
  }

  const brand = searchParams.getAll('brand');
  if (brand.length > 0) {
    filters.brand = brand;
  }

  const volatilityFrom = searchParams.get('volatility_from');
  const volatilityTo = searchParams.get('volatility_to');
  if (volatilityFrom && volatilityTo) {
    filters.volatility = [volatilityFrom, volatilityTo];
  }

  const rtpFrom = searchParams.get('rtp_from');
  const rtpTo = searchParams.get('rtp_to');
  if (rtpFrom && rtpTo) {
    filters.rtp = [[rtpFrom, rtpTo]];
  }

  const releaseDateFrom = searchParams.get('release_date_from');
  if (releaseDateFrom) {
    filters.releaseDate = [releaseDateFrom];
  }

  const releaseDateTo = searchParams.get('release_date_to');
  if (releaseDateTo) {
    const current = filters.releaseDate || [];
    filters.releaseDate =
      current.length > 0
        ? [current[0], releaseDateTo]
        : ['', releaseDateTo];
  }

  return filters;
};

export const updateSearchParamsWithFilters = (
  current: URLSearchParams,
  newFilters: Partial<FilterSchema>,
): URLSearchParams => {
  const next = new URLSearchParams(current);

  const filterParamKeys = [
    'market',
    'language',
    'game_status',
    'game_features',
    'game_family',
    'game_groups',
    'game_providers',
    'file_type_compliance',
    'file_format_compliance',
    'file_type_marketing',
    'file_format_marketing',
    'partner_type',
    'platform',
    'operator',
    'brand',
    'volatility_from',
    'volatility_to',
    'rtp_from',
    'rtp_to',
    'release_date_from',
    'release_date_to',
  ] as const;

  filterParamKeys.forEach((key) => next.delete(key));

  if (newFilters.market && newFilters.market.length > 0) {
    newFilters.market.forEach((m) => {
      next.append('market', String(m));
    });
  }

  if (newFilters.language && newFilters.language.length > 0) {
    newFilters.language.forEach((l) => {
      next.append('language', l);
    });
  }

  if (newFilters.gameStatus && newFilters.gameStatus.length > 0) {
    newFilters.gameStatus.forEach((status) => {
      next.append('game_status', status);
    });
  }

  if (newFilters.gameFeatures && newFilters.gameFeatures.length > 0) {
    newFilters.gameFeatures.forEach((feature) => {
      next.append('game_features', feature);
    });
  }

  if (newFilters.gameFamily && newFilters.gameFamily.length > 0) {
    newFilters.gameFamily.forEach((family) => {
      next.append('game_family', family);
    });
  }

  if (newFilters.gameGroups && newFilters.gameGroups.length > 0) {
    newFilters.gameGroups.forEach((group) => {
      next.append('game_groups', group);
    });
  }

  if (
    newFilters.gameProviders &&
    newFilters.gameProviders.length > 0
  ) {
    newFilters.gameProviders.forEach((provider) => {
      next.append('game_providers', provider);
    });
  }

  if (
    newFilters.fileTypeCompliance &&
    newFilters.fileTypeCompliance.length > 0
  ) {
    newFilters.fileTypeCompliance.forEach((type) => {
      next.append('file_type_compliance', type);
    });
  }

  if (
    newFilters.fileFormatCompliance &&
    newFilters.fileFormatCompliance.length > 0
  ) {
    newFilters.fileFormatCompliance.forEach((format) => {
      next.append('file_format_compliance', format);
    });
  }

  if (
    newFilters.fileTypeMarketing &&
    newFilters.fileTypeMarketing.length > 0
  ) {
    newFilters.fileTypeMarketing.forEach((type) => {
      next.append('file_type_marketing', type);
    });
  }

  if (
    newFilters.fileFormatMarketing &&
    newFilters.fileFormatMarketing.length > 0
  ) {
    newFilters.fileFormatMarketing.forEach((format) => {
      next.append('file_format_marketing', format);
    });
  }

  if (newFilters.partnerType && newFilters.partnerType.length > 0) {
    newFilters.partnerType.forEach((type) => {
      next.append('partner_type', type);
    });
  }

  if (newFilters.platform && newFilters.platform.length > 0) {
    newFilters.platform.forEach((p) => {
      next.append('platform', p);
    });
  }

  if (newFilters.operator && newFilters.operator.length > 0) {
    newFilters.operator.forEach((o) => {
      next.append('operator', o);
    });
  }

  if (newFilters.brand && newFilters.brand.length > 0) {
    newFilters.brand.forEach((b) => {
      next.append('brand', b);
    });
  }

  if (newFilters.volatility && newFilters.volatility.length === 2) {
    const [from, to] = newFilters.volatility;
    if (from && to) {
      next.set('volatility_from', String(from));
      next.set('volatility_to', String(to));
    }
  }

  if (newFilters.rtp && newFilters.rtp.length === 1) {
    const [from, to] = newFilters.rtp[0] || [];
    if (from && to) {
      next.set('rtp_from', from);
      next.set('rtp_to', to);
    }
  }

  if (
    newFilters.releaseDate &&
    newFilters.releaseDate.length > 0 &&
    newFilters.releaseDate[0]
  ) {
    next.set(
      'release_date_from',
      newFilters.releaseDate[0] as string,
    );
  }

  if (
    newFilters.releaseDate &&
    newFilters.releaseDate.length > 1 &&
    newFilters.releaseDate[1]
  ) {
    next.set('release_date_to', newFilters.releaseDate[1] as string);
  }

  return next;
};

export const parseSearchHitPath = (
  rawPath: string | undefined,
  hiddenRoot?: string,
): string | undefined => {
  if (rawPath == null || rawPath === '') return rawPath;

  const trimmed = rawPath.replace(/\/+$/, '');
  if (trimmed === '') return rawPath;

  const lastSlashIndex = trimmed.lastIndexOf('/');
  if (lastSlashIndex === -1) {
    return hiddenRoot ? `${hiddenRoot}/${trimmed}` : trimmed;
  }

  const lastSegment = trimmed.slice(lastSlashIndex + 1);
  const collapsed = `/${lastSegment}`;

  return hiddenRoot ? `${hiddenRoot}${collapsed}` : collapsed;
};
